<template>
    <router-view/>
    <preview-course v-if="openClosePreview" :previewId="previewId" :previewType="previewType"></preview-course>
    <div class="banner-update-app" v-if="isRefresh && this.$route.name != 'notifications'">  
        <div class="text-center">
          <h5><i class="las la-bullhorn text-primary"></i> Nueva Actualización Disponible</h5>
          <p class="small m-0 mb-2">Necesitamos que vuelvas a recargar el sitio para sumar las nuevas actualizaciones.</p>
          <button class="btn btn-outline-primary mx-auto" @click="updateApp()">Recargar</button>
        </div>
    </div>
    <div class="d-flex justify-content-center align-items-center h-100 w-100 screen-waiting" v-if="this.showWait == true">
        <div>
            <img src="@/assets/imgs/spinner-white.webp" class="img-fluid w-25">
            <h3>{{waitingMsg}}</h3>    
        </div>
    </div>
    <pdf-reader-iframe v-if="pdfShow" :url="pdfUrl"></pdf-reader-iframe>
    <div v-if="imgShow" class="img-reader">
      <div class="w-100 vh-100 bg-white"> 
        <img :src="imgReader" class="img-fluid">
        <button @click="closeImg()" class="btn btn-primary w-50 btn-iframe">Cerrar</button>
      </div>
    </div>
    <expand-info v-if="openCloseContact" ref="help" :openHelp="this.openCloseContact" @openHelp="openHelp" :refId="this.contactId"></expand-info>
    <div id="tour-screen-blocker" v-if="tourScreenblocker"></div>
    <div class="modal fade" id="modalTour" tabindex="-1" aria-labelledby="" aria-hidden="true" ref="modalTour">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-gradient-green text-white">
                    <h5 class="modal-title"><i class="la la-route me-2"></i>Guías paso a paso</h5>
                    <button type="button" class="btn-close text-white" style="filter: invert(1);" @click="modalTour.hide()"></button>
                </div>
                <div class="modal-body text-center" style="background-image: url(/img/dot-plane.jpg); background-repeat: no-repeat; background-position: bottom; background-size: contain;">  
                  <p class="text-center mb-4 fw-light text-blue d-none d-sm-block">
                    Elige una guía y te acompañaremos por la plataforma con indicaciones interactivas que te mostrarán qué hacer en cada paso.
                  </p>

                  <!-- Guía 1 -->
                  <div class="text-start mb-3">
                    <p class="small mb-2 fst-italic lh-1" style="font-size: 0.9rem;">
                      <i class="las la-circle text-green"></i> Recorrido por la pantalla principal
                      <a class="pointer d-none d-sm-inline" style="font-size: 0.8rem;" @click="startTour('stepsBienvenida', false, false, true)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                      <a class="pointer d-inline d-sm-none" style="font-size: 0.8rem;" @click="startTour('stepsBienvenidaMobile', false, false, true)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                    </p>
                  </div>

                  <!-- Guía 3 -->
                  <div class="text-start mb-3">
                    <p class="small mb-2 fst-italic lh-1" style="font-size: 0.9rem;">
                      <i class="las la-circle text-green"></i> Configura tus cobros por transferencia bancaria
                      <a class="pointer d-none d-sm-inline" style="font-size: 0.8rem;" @click="startTour('stepsDatosBancarios', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                      <a class="pointer d-inline d-sm-none" style="font-size: 0.8rem;" @click="startTour('stepsDatosBancariosMobile', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                    </p>
                  </div>

                  <!-- Guía 5 -->
                  <div class="text-start mb-3">
                    <p class="small mb-2 fst-italic lh-1" style="font-size: 0.9rem;">
                      <i class="las la-circle text-green"></i> Vincula tu Google Calendar
                      <a class="pointer d-none d-sm-inline" style="font-size: 0.8rem;" @click="startTour('stepsGcalendar', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                      <a class="pointer d-inline d-sm-none" style="font-size: 0.8rem;" @click="startTour('stepsGcalendarMobile', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                    </p>
                  </div>

                  <!-- Guía 2 -->
                  <div class="text-start mb-3">
                    <p class="small mb-2 fst-italic lh-1" style="font-size: 0.9rem;">
                      <i class="las la-circle text-green"></i> Otorga una cita/turno manual
                      <a class="pointer d-none d-sm-inline" style="font-size: 0.8rem;" @click="startTour('stepsTurnoManual', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                      <a class="pointer d-inline d-sm-none" style="font-size: 0.8rem;" @click="startTour('stepsTurnoManualMobile', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                    </p>
                  </div>
                  <!-- Guía 6 -->
                  <div class="text-start mb-3">
                    <p class="small mb-2 fst-italic lh-1" style="font-size: 0.9rem;">
                      <i class="las la-circle text-green"></i> Crea el link de un servicio para compartir la disponibilidad de tu agenda
                      <a class="pointer d-none d-sm-inline" style="font-size: 0.8rem;" @click="startTour('stepsServices', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                      <a class="pointer d-inline d-sm-none" style="font-size: 0.8rem;" @click="startTour('stepsServicesMobile', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                    </p>
                  </div>
                  <!-- Guía 4 -->
                  <div class="text-start mb-3">
                    <p class="small mb-2 fst-italic lh-1" style="font-size: 0.9rem;">
                      <i class="las la-circle text-green"></i> Configura tus cobros con tarjetas de crédito o débito
                      <a class="pointer d-none d-sm-inline" style="font-size: 0.8rem;" @click="startTour('stepsTarjetas', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                      <a class="pointer d-inline d-sm-none" style="font-size: 0.8rem;" @click="startTour('stepsTarjetasMobile', true, false, false)">
                        <i class="la la-play me-1"></i>Comenzar
                      </a>
                    </p>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>   
import previewCourse from '@/components/edit-service/preview-course.vue'
import pdfReaderIframe from '@/components/my-account/pdf-reader-iframe.vue'
import { Modal } from "bootstrap";
import expandInfo from '@/components/nav/expand-info.vue'
import { TourGuideClient } from '@sjmc11/tourguidejs';
import '@sjmc11/tourguidejs/dist/css/tour.min.css';
export default{
  components: {
      pdfReaderIframe,
      previewCourse,
      expandInfo
  },
  data(){
        return{
          openClose: false, 
          openTutorial: '',
          titleTutorial: '',
          registration:null,
          isRefresh: false,
          refreshing: false,
          pdfUrl: '',
          pdfShow: false,
          showWait: false,
          waitingMsg: '',
          previewId: '',
          previewType: '',
          openClosePreview: false,
          imgReader: '',
          imgShow: false,
          contactId: '',
          openCloseContact: false,
          tour: null,
          isTourActive: false,
          steps: null,
          propagateEvents: false,
          hideNext: false,
          modalTour: null,
          tourScreenblocker: false,
          stepsBienvenida: [
            {
              title: 'Bienvenida',
              content: '<div class="text-center"><b class="text-blue">¡Te damos la bienvenida a Animasana!</b><br><br>En menos de <b>5 minutos</b> te mostraremos un pantallazo general de la plataforma y lo primero que tienes que hacer para empezar a usarla.</div>',
              target: 'body',
              placement: 'bottom',
            },
            {
              title: 'Guías paso a paso',
              content: 'Podrás volver a ver esta guía paso a paso y otras desde aquí.',
              target: '.btnTourGuide',
              placement: 'bottom',
            },   
            {
              title: 'Calendario',
              content: 'Aquí puedes visualizar tus citas, talleres y eventos programados. También tienes la opción de vincularlo con tu cuenta de Google Calendar.',
              target: '.new-cal',
              placement: 'top',
            },
            {
              title: 'Navegación por días',
              content: 'Usa estas flechas para desplazarte hacia adelante o hacia atrás en el calendario.',
              target: '#btn-cal-arrow',
              placement: 'bottom',
            },
            {
              title: 'Volver a hoy',
              content: 'Haz clic en el botón <b>Hoy</b> para regresar rápidamente a la fecha actual en el calendario.',
              target: '.btn-cal-now',
              placement: 'bottom',
            },
            {
              title: 'Crear cita o evento',
              content: 'Desde este botón puedes crear una cita manual o un evento personal. También puedes hacerlo haciendo clic en cualquier parte libre del calendario.',
              target: '#createBtnTurn',
              placement: 'right',
            },
            {
              title: 'Calendario rápido',
              content: 'Usa este calendario miniatura para navegar rápidamente a otro día. Al hacer clic en un día, el calendario principal se posicionará allí.',
              target: '.mini-cal',
              placement: 'right',
            },
            {
              title: 'Días no laborables',
              content: 'Desde aquí puedes bloquear fechas específicas. Las publicaciones con selección de turnos no ofrecerán citas en los días marcados como no laborables.',
              target: '.no-work-day',
              placement: 'right',
            },
            {
              title: 'Guía de colores',
              content: 'Esta guía te ayudará a identificar fácilmente el estado de las citas, eventos o talleres por su color.',
              target: '#textStatusColors',
              placement: 'right',
            },
            {
              title: 'Agenda',
              content: '<b>Agenda</b> es la pantalla principal donde estás actualmente.',
              target: '.my-toolsss',
              placement: 'top',
            },
            {
              title: 'Servicios',
              content: 'En <b>Servicios</b> puedes crear citas automáticas o publicaciones para que tus consultantes elijan día y horario según su conveniencia.',
              target: '.my-servicesss',
              placement: 'top',
            },
            {
              title: 'Contactos',
              content: 'Desde <b>Contactos</b> accedes a las fichas de los consultantes, opciones de pago, datos de contacto e historia clínica.',
              target: '.clientsss',
              placement: 'top',
            },
            {
              title: 'Cobros',
              content: 'En <b>Cobros</b> encontrarás todas tus contrataciones, promedios mensuales y la posibilidad de descargar esta información.',
              target: '.billingss',
              placement: 'top',
            },
            {
              title: 'Talleres',
              content: 'En <b>Talleres</b> puedes crear y actualizar tus cursos, subir contenido, agregar certificados, tu firma y cuestionarios.',
              target: '.my-workshopsss',
              placement: 'top',
            },
            {
              title: 'Sitio Web',
              content: 'Desde <b>Web</b> puedes personalizar tu sitio con tu nombre, logos, biografía, y decidir qué publicaciones mostrar. También puedes copiar el enlace para compartirlo.',
              target: '.my-businessss',
              placement: 'top',
            },
            {
              title: 'Post',
              content: 'En <b>Post</b> puedes generar contenido visual y textual con Inteligencia Artificial para tus redes, usando tus servicios como base.',
              target: '#post-generatorss',
              placement: 'top',
            },
            {
              title: 'Ajustes',
              content: 'En <b>Ajustes</b> puedes modificar tu perfil, métodos de cobro, planes, vincular Google Calendar, generar códigos de descuento, entre otras configuraciones.',
              target: '.my-profiless',
              placement: 'top',
            }, 
            {
              title: 'Final del recorrido',
              content: '<div class="text-center"><b class="text-blue">¡Has completado el recorrido!</b><br><br>Ya conoces las principales funciones de Animasana. ¡Ahora es momento de comenzar a disfrutar la experiencia!</div>',
              target: 'body',
              placement: 'top',
              hidePrev: false,
            },
          ],
          stepsBienvenidaMobile: [
            {
              title: 'Bienvenida',
              content: '<div class="text-center"><b class="text-blue">¡Te damos la bienvenida a Animasana!</b><br><br>En menos de <b>5 minutos</b> te mostraremos un pantallazo general de la plataforma y lo primero que tienes que hacer para empezar a usarla.</div>',
              target: 'body',
              placement: 'bottom',
            },
            {
              title: 'Calendario',
              content: 'Desde aquí puedes visualizar tus citas, talleres y eventos programados. Desliza con los dedos para moverte entre fechas. También puedes vincularlo con tu cuenta de Google Calendar.',
              target: 'body',
              placement: 'top',
            },
            {
              title: 'Opciones',
              content: 'Al tocar este ícono se despliegan más opciones del calendario, como vistas disponibles, navegación por fechas y configuración de días no laborables.',
              target: '.paper-nav-toggle',
              placement: 'bottom',
            },
            {
              title: 'Agenda',
              content: '<b>Agenda</b> es la pantalla principal donde gestionas tu día a día con Animasana.',
              target: '.my-toolsss',
              placement: 'top',
            },
            {
              title: 'Servicios',
              content: 'En <b>Servicios</b> puedes crear citas automáticas o publicaciones para que tus consultantes reserven día y horario fácilmente.',
              target: '.my-servicesss',
              placement: 'top',
            },
            {
              title: 'Contactos',
              content: 'Desde <b>Contactos</b> accedes a las fichas de tus consultantes, datos de contacto, historial clínico y opciones de pago personalizadas.',
              target: '.clientsss',
              placement: 'top',
            },
            {
              title: 'Cobros',
              content: 'En <b>Cobros</b> puedes ver tus ingresos, estadísticas mensuales y descargar tus registros de contrataciones.',
              target: '.billingss',
              placement: 'top',
            },
            {
              title: 'Sitio Web',
              content: 'Desde <b>Web</b> personalizas tu sitio con nombre, logos, biografía y publicaciones visibles. También puedes copiar el enlace para compartirlo fácilmente.',
              target: '.my-businessss',
              placement: 'top',
            },
            {
              title: 'Ajustes',
              content: 'En <b>Ajustes</b> configuras tu perfil, métodos de cobro, plan activo, conexión con Google Calendar, códigos de descuento y más opciones.',
              target: '.config-icon-mobile',
              placement: 'bottom',
            },
            {
              title: 'Talleres',
              content: '<div class="text-center">Desde una computadora, también puedes crear y gestionar talleres y cursos con acceso a más herramientas.</div>',
              target: 'body',
              placement: 'bottom',
            },
            {
              title: 'Guías paso a paso',
              content: 'Podrás volver a ver esta guía paso a paso y otras desde aquí.',
              target: '.btnTourGuide',
              placement: 'bottom',
            },   
            {
              title: 'Final del recorrido',
              content: '<div class="text-center"><b class="text-blue">¡Recorrido finalizado!</b><br><br>Ya conoces las principales funciones de Animasana. ¡Ahora es momento de comenzar a disfrutar la experiencia!</div>',
              target: 'body',
              placement: 'top',
              hidePrev: false,
            },
          ],
          stepsTurnoManual: [
            {
              title: 'Paso 1',
              content: 'Para asignar una cita manual, primero haz clic en <b>Crear</b>.',
              target: '#createBtnTurn',
              placement: 'bottom',
            },
            {
              title: 'Paso 2',
              content: 'Ahora haz clic en <b>Cita con consultante</b>.',
              target: '#DialogCreateBtnTurn',
              placement: 'bottom',
            },
            {
              title: 'Paso 3',
              content: 'Si aún no tienes registrado al consultante, haz clic en <b>Usuario nuevo</b>.',
              target: '#turnTabNewUser',
              placement: 'top',
            },
            {
              title: 'Paso 4',
              content: 'Completa los datos del consultante y luego haz clic en <b>Agregar y configurar cita</b>.',
              target: '#register-form',
              placement: 'top',
            },
            {
              title: 'Paso 5',
              content: 'Por último, completa los datos de la cita que deseas otorgar al consultante. Una vez listo, haz clic en <b>Confirmar</b>.',
              target: '.pop-cal',
              placement: 'left',
            },
            {
              title: '¡Listo!',
              content: '¡Has asignado una cita manual a un usuario nuevo!<br>La próxima vez que quieras otorgar una cita al mismo consultante, solo deberás elegir día y horario en la agenda y buscarlo.',
              target: '.pop-cal',
              placement: 'top',
            },
          ],
          stepsTurnoManualMobile: [
            {
              title: 'Paso 1',
              content: 'Para asignar una cita manual, primero haz clic en <b>Crear</b>.',
              target: '.btn-mobile-add-event',
              placement: 'bottom',
            },
            {
              title: 'Paso 2',
              content: 'Ahora haz clic en <b>Cita con consultante</b>.',
              target: '#DialogCreateBtnTurn',
              placement: 'bottom',
            },
            {
              title: 'Paso 3',
              content: 'Si aún no tienes registrado al consultante, haz clic en <b>Usuario nuevo</b>.',
              target: '#turnTabNewUser',
              placement: 'top',
            },
            {
              title: 'Paso 4',
              content: 'Completa los datos del consultante y luego haz clic en <b>Agregar y configurar cita</b>. Luego podrás otorgar la cita al consultante.',
              target: 'body',
              placement: 'top',
            }
          ],
          stepsDatosBancarios: [
            {
              title: 'Paso 1',
              content: 'Para habilitar los cobros por transferencia, primero debes configurar tus datos bancarios. Haz clic en <b>Ajustes</b>.',
              target: '.myProfileTour',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Dentro de Ajustes, haz clic en <b>Métodos de cobro</b> para continuar.',
              target: '.my-charges',
              placement: 'right',
            },
            {
              title: 'Paso 3',
              content: 'Haz clic en el ícono del lápiz para editar tus datos bancarios y habilitar los cobros por transferencia.',
              target: '.tourBankData',
              placement: 'top',
            },
            {
              title: 'Paso 4',
              content: 'Completa tus datos bancarios y haz clic en <b>Guardar</b> para finalizar la configuración.',
              target: '#edit-user-data',
              placement: 'left',
            },
            {
              title: '¡Listo!',
              content: '<div class="text-center">Tus datos bancarios ya están configurados. Ahora, al activar la opción de cobro por transferencia en tus servicios, tus consultantes recibirán automáticamente la información para realizar el pago.</div>',
              target: '#edit-user-data',
              placement: 'bottom',
            },
          ],
          stepsDatosBancariosMobile: [
            {
              title: 'Paso 1',
              content: 'Para habilitar los cobros por transferencia bancaria, primero accede a la configuración tocando en <b>Ajustes</b>.',
              target: '.config-icon-mobile',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Dentro del menú de ajustes, selecciona la opción <b>Métodos de cobro</b> para continuar.',
              target: '.my-charges',
              placement: 'right',
            },
            {
              title: 'Paso 3',
              content: 'Toca el ícono del lápiz para editar tus datos bancarios.',
              target: '.tourBankData',
              placement: 'top',
            },
            {
              title: 'Paso 4',
              content: 'Completa el formulario con tus datos bancarios para habilitar los cobros por transferencia.',
              target: '#edit-user-data',
              placement: 'left',
            },
            {
              title: '¡Todo listo!',
              content: '<div class="text-center">Ya puedes recibir pagos mediante transferencia bancaria.</div>',
              target: '#edit-user-data',
              placement: 'bottom',
            },
          ],
          stepsTarjetas: [
            {
              title: 'Paso 1',
              content: 'Para habilitar los cobros con tarjetas de crédito o débito, primero debes vincular una pasarela de pago. Haz clic en <b>Ajustes</b>.',
              target: '.myProfileTour',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Dentro de Ajustes, haz clic en <b>Métodos de cobro</b> para continuar.',
              target: '.my-charges',
              placement: 'right',
            },
            {
              title: 'Paso 3',
              content: 'Haz clic en el ícono del lápiz para vincular la pasarela de pagos.',
              target: '.tourCard',
              placement: 'top',
            },
            {
              title: 'Paso 4',
              content: 'Haz clic en el botón <b>Vincular</b> y luego acepta los permisos que se te soliciten para poder cobrar con tarjetas en Animasana.',
              target: '#edit-user-bank',
              placement: 'left',
            }
          ],        
          stepsTarjetasMobile: [
            {
              title: 'Paso 1',
              content: 'Para habilitar los cobros con tarjetas de crédito o débito, primero accede a la configuración tocando en <b>Ajustes</b>.',
              target: '.config-icon-mobile',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Dentro del menú de ajustes, selecciona la opción <b>Métodos de cobro</b> para continuar.',
              target: '.my-charges',
              placement: 'right',
            },
            {
              title: 'Paso 3',
              content: 'Toca el ícono del lápiz para vincular la pasarela de pagos. Luego deberás pulsar el botón <b>Vincular</b> y aceptar los permisos que se te soliciten.',
              target: '.tourCard',
              placement: 'top',
            }
          ],
          stepsGcalendar: [
            {
              title: 'Paso 1',
              content: 'Para sincronizar Google Calendar, primero se debe vincular la cuenta. Toca en <b>Ajustes</b>.',
              target: '.myProfileTour',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Luego, selecciona la opción <b>Sincronizar con Google Calendar</b>.',
              target: '.publish-services',
              placement: 'right',
            },
            {
              title: 'Paso 3',
              content: 'Toca el botón <b>Proceder</b> y acepta los permisos que se soliciten para completar la sincronización.',
              target: '#edit-user-bank',
              placement: 'top',
            }
          ],
          stepsGcalendarMobile: [
            {
              title: 'Paso 1',
              content: 'Para sincronizar Google Calendar, primero debes vincular tu cuenta. Toca en <b>Ajustes</b>.',
              target: '.config-icon-mobile',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Ahora, selecciona la opción <b>Sincronizar con Google Calendar</b>. Luego al hacer click en <b>Proceder</b> deberás aceptar los permisos que se soliciten para completar la sincronización.',
              target: '.publish-services',
              placement: 'right',
            }
          ],
          stepsServices: [
            {
              title: 'Paso 1',
              content: 'Para crear una publicación del servicio que ofreces, haz clic en <b>Servicios</b>.',
              target: '.my-servicesss',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Luego, haz clic en <b>Publicar nuevo servicio</b>. El asistente de publicación te guiará paso a paso en el proceso.',
              target: '.new-publish',
              placement: 'right',
            }
          ],
          stepsServicesMobile: [
            {
              title: 'Paso 1',
              content: 'Para crear una publicación del servicio que ofreces, toca en <b>Servicios</b>.',
              target: '.my-servicesss',
              placement: 'top',
            },
            {
              title: 'Paso 2',
              content: 'Luego, toca en <b>Publicar nuevo servicio</b>. El asistente de publicación te guiará paso a paso en el proceso.',
              target: '.new-publish',
              placement: 'right',
            }
          ],
        }
  },
  mounted: function () { 

  },
  created() {
    document.addEventListener(
        'serviceWorkerUpdateEvent', this.appUpdateUI, { once: true }
    );
    navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return;
          if(this.$route.name != 'notifications'){
            this.refreshing = true;
            window.location.reload();
          }
        }
    );
  },
  
  methods: {
    corporatePermissions(key) {
      try {
        const raw = localStorage.getItem('corporatePermitions');
        if (!raw) return false;

        const permissions = JSON.parse(raw);
        return !!permissions[key];
      } catch (e) {
        return false;
      }
    },
    openModalTour(){
        var modal = new Modal(document.querySelector('#modalTour'))
        this.modalTour = modal;
        modal.show()
    },
    initTour() {  
      this.tour = new TourGuideClient({
        hideNext: this.hideNext,
        nextLabel: 'Siguiente',
        hidePrev: this.hideNext,
        prevLabel: 'Anterior',
        finishLabel: 'Finalizar',
        backdropColor: 'rgba(0, 65, 147, 0.5)',
        dialogZ: 10000000000000,
        progressBar: true,
        autoScroll: true,
        steps: this.steps,
        completeOnFinish: true,
        enableInteraction: true,
        propagateEvents: false,
        exitOnClickOutside: false,
        rememberStep: true,
        showStepDots: false,
        dialogMaxWidth: 250,
        targetPadding: 7,
      })
      this.tour.refresh();
      this.tour.start()
      this.tour.onBeforeExit(() => {
        this.tour = null;
        this.isTourActive = false;
        this.tourScreenblocker = false;
        document.querySelectorAll('.tg-active-element').forEach(el => {
          el.classList.remove('tg-active-element');
        });
        //this.openModalTour();
      })
      this.tour.onFinish(() => {
        try{
          localStorage.removeItem('newUser');
        }catch(e){

        }
        this.tour = null;
        this.isTourActive = false;
        this.tourScreenblocker = false;
        this.openModalTour();
        document.querySelectorAll('.tg-active-element').forEach(el => {
          el.classList.remove('tg-active-element');
        });
      })
      this.isTourActive = true
    },

    nextStepTour(val){
      if (this.tour) {
        setTimeout(() => {
          const dialog = document.querySelector('.tg-dialog');
          if (dialog) {
            dialog.classList.remove('minimized');
          }
          const backdrop = document.querySelector('.tg-backdrop');
          if (backdrop) {
            backdrop.classList.remove('minimized');
          }
          this.tour.nextStep()
          setTimeout(() => {
            this.tour.updatePositions(); // No refresca todo, solo ajusta el paso activo
          }, 800);
        }, 400)
      }
    },
    finishTour(){
      if (this.tour) { 
        this.tour.exit()
        this.tour = null 
        this.steps = null
        this.hideNext = false;
        this.propagateEvents = false;
        this.tourScreenblocker = false;
        try{
          localStorage.removeItem('newUser');
        }catch(e){

        }
        this.openModalTour();
      }
    },
    finishTour(){
      if (this.tour) { 
        this.tour.exit()
        this.tour = null 
        this.steps = null
        this.hideNext = false;
        this.propagateEvents = false;
        this.tourScreenblocker = false;
        this.openModalTour();
      }
    },
    finishTourClose(){
      if (this.tour) { 
        this.tour.exit()
        this.tour = null 
        this.steps = null
        this.hideNext = false;
        this.propagateEvents = false;
        this.tourScreenblocker = false;
      }
    },
    startTour(val, hideNext, propagateEvents, tourScreenblocker) {
      this.$router.push({ name: 'my-tools' }).then(() => {
        setTimeout(() => {
          // Ahora sí, la navegación terminó y la nueva vista está montada
          if (this.tour) { 
            this.tour.exit(); 
          }
          this.tour = null;
          this.steps = null;
          this.hideNext = hideNext;
          this.propagateEvents = propagateEvents;
          this.tourScreenblocker = tourScreenblocker;
          if(this.modalTour){
            this.modalTour.hide();
          }

          try {
            const backdrop = document.querySelectorAll('.tg-backdrop');
            backdrop.forEach(d => d.remove());
            const dialogs = document.querySelectorAll('.tg-dialog');
            dialogs.forEach(d => d.remove());
          } catch (e) {
            // manejo silencioso del error
          }

          if (val === 'stepsTurnoManual') {
            this.steps = JSON.parse(JSON.stringify(this.stepsTurnoManual));
          } else if (val === 'stepsTurnoManualMobile') {
            this.steps = JSON.parse(JSON.stringify(this.stepsTurnoManualMobile));
          } else if (val === 'stepsBienvenida') {
            this.steps = JSON.parse(JSON.stringify(this.stepsBienvenida));
          } else if (val === 'stepsBienvenidaMobile') {
            this.steps = JSON.parse(JSON.stringify(this.stepsBienvenidaMobile));
          } else if (val === 'stepsDatosBancarios') {
            this.steps = JSON.parse(JSON.stringify(this.stepsDatosBancarios));
          } else if (val === 'stepsDatosBancariosMobile') {
            this.steps = JSON.parse(JSON.stringify(this.stepsDatosBancariosMobile));
          } else if (val === 'stepsTarjetas') {
            this.steps = JSON.parse(JSON.stringify(this.stepsTarjetas));
          } else if (val === 'stepsTarjetasMobile') {
            this.steps = JSON.parse(JSON.stringify(this.stepsTarjetasMobile));
          } else if (val === 'stepsGcalendar') {
            this.steps = JSON.parse(JSON.stringify(this.stepsGcalendar));
          } else if (val === 'stepsGcalendarMobile') {
            this.steps = JSON.parse(JSON.stringify(this.stepsGcalendarMobile));
          } else if (val === 'stepsServices') {
            this.steps = JSON.parse(JSON.stringify(this.stepsServices));
          } else if (val === 'stepsServicesMobile') {
            this.steps = JSON.parse(JSON.stringify(this.stepsServicesMobile)); 
          }

          setTimeout(() => {
            this.initTour();
          }, 1000);
        }, 1000);

      }).catch(err => {
        console.error('Error navegando:', err);
      });
      
    },  
    expandContact(val){
      this.contactId = '';
      this.openCloseContact = false;
      var a = this;  
      setTimeout(function(){   
        a.contactId = val;
        a.openCloseContact = true;
      }, 200); 
      this.type = a.type;
      this.openCloseContact = a.openCloseContact;
    },
    closeContact(){
      this.openCloseContact = false;
    },
    closePdf(){
      try{
        document.querySelector('body').style.height = '';
        document.querySelector('body').style.overflow = '';
      }catch(e){

      }
      this.pdfShow = false;
      this.pdfUrl = '';
    },
    openPdf(val){ 
      if(window.innerWidth > 572){
        try{
          document.querySelector('body').style.height = '100dvh';
          document.querySelector('body').style.overflow = 'hidden';
        }catch(e){

        }    
        this.pdfUrl = val;
        this.pdfShow = true;
      }else{
        var anchor = document.createElement('a');
        anchor.href = val;
        anchor.target="_blank";
        anchor.click();
      }
    },
    closeImg(){
      try{
        document.querySelector('body').style.height = '';
        document.querySelector('body').style.overflow = '';
      }catch(e){

      }
      this.imgShow = false;
      this.imgReader = '';
    },
    openImg(val){     
      if(window.innerWidth > 572){
        try{
          document.querySelector('body').style.height = '100dvh';
          document.querySelector('body').style.overflow = 'hidden';
        }catch(e){

        }    
        this.imgReader = val;
        this.imgShow = true;
      }else{
        var anchor = document.createElement('a');
        anchor.href = val;
        anchor.target="_blank";
        anchor.click();
      }
    },
    showWaiting(val){ 
      this.waitingMsg = val;
      this.showWait = true;
    },
    hideWaiting(){
      this.showWait = false;
      this.waitingMsg = '';
    },
    openPreview(val1, val2){
      this.previewId = val1;
      this.previewType = val2;
      this.openClosePreview = false;
      var d =  this;
      setTimeout(function(){ d.openClosePreview = true; }, 200);
    },
    closePreview(){
      this.previewId = '';
      this.previewType = '';
      this.openClosePreview = false;
    },
    openHelp(val){
      this.titleTutorial = '';
      this.openTutorial = '';
      if(val == '' && this.openClose == true){
        this.openClose = false;
      }else{
        this.openClose = true;
      }
    },
    openTutorialHelp(val1, val2){
      this.openClose = false;
      this.titleTutorial = val2;
      this.openTutorial = val1;
      var d =  this;
      setTimeout(function(){ d.openClose = true; }, 200);
   
    },
    appUpdateUI:function (e){
      this.registration = e.detail;
      this.isRefresh = true;
    },
    updateApp(){
     this.isRefresh = false;
     if (this.registration || this.registration.waiting) {
       this.registration.waiting.postMessage({type:'SKIP_WAITING'});
     }
   },
  },
  
}
</script>

<style lang="css" src="./assets/styles/custom.css" />
<style lang="css" src="./assets/styles/animate.css" />
<style lang="css" src="@/assets/styles/slim.min.css" />
<style>
b, strong {
    font-weight: bolder !important;
}
/* tour */
.tg-dialog .tg-dialog-progress-bar {
    background: #f1f1f1;
    height: 5px;
    display: block;
    margin-top: 12.75px;
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 9px;
    overflow: hidden;
}
.tg-dialog .tg-dialog-progress-bar>.tg-bar{
    position: absolute;
    top: 0;
    left: 0;
    min-width: 4px;
    background: #05c8a3;
    height: 100%;
    display: block;
    transition: all 300ms;
}
.tg-dialog .tg-dialog-dots>span.tg-dot.tg-dot-active {
    background: #004193;
}
.tg-dialog .tg-dialog-header {
    display: flex;
    align-items: center;
    padding: 1px 15px 0 15px;
}
.tg-dialog .tg-dialog-header .tg-dialog-title {
    font-size: 1rem;
    font-weight: 700;
    margin-right: auto;
    color: #00c7a2;
    margin-top: 10px;
}
.tg-backdrop{
  z-index: 100000000000000000000;
}

.tg-dialog.minimized, .tg-backdrop.minimized{
  transform: scale(0.1);
  opacity: 0.2;
  pointer-events: none;
  transition: all 0.3s ease;
}
.tg-dialog .tg-dialog-footer button.tg-dialog-btn{
  border-radius: 15px;
}
.tg-dialog .tg-dialog-footer .tg-dialog-footer-sup .tg-step-progress{
  color: #004193;
  opacity: 1;
}
.tg-dialog .tg-dialog-footer button.tg-dialog-btn:active{
  color: #004193;
  border: 1px solid #004193;
  background-color: #00419342;
}
#tour-screen-blocker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent; /* o rgba(0,0,0,0.1) si querés oscurecer */
  z-index: 100000000000000000000; /* debe estar debajo de tg-dialog, que tiene un z-index muy alto */
  pointer-events: all !important; /* bloquea clics */
}
</style>
<style scoped>
.screen-waiting{
    position: fixed;
    z-index: 9000000;
    text-align: center;
    background: #004193;
    color: #fff;
    top:0;
    left: 0;
}
.banner-update-app{
  position: fixed;
    z-index: 2000001;
    bottom: 0;
    width: 100%;
    background: #000;
    color: #fff;
    height: auto;
    padding: 10px;
}


.img-reader{
  position: absolute;
  z-index: 91000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.img-reader .btn-iframe{
    position: fixed;
    z-index: 2;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 10px;
    margin: auto;
}


</style>

        
